import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { pc } from "components/mixins/mediaQuery";
import { color } from "components/mixins";
import tag from "images/icons/tag.svg";
import { Tag } from "components/Manual/demoData";
import { generateTailwindHtmlDoc } from "utils/tailwindHtmlGenerator";
interface ManualEditContentProps {
  title: string;
  tags: Tag[];
  currentTagIds: { id: number }[];
  content: string;
  isPublished: boolean;
}

function ManualEditPreviewContent(props: ManualEditContentProps) {
  const { title, tags, currentTagIds, content, isPublished } = props;
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // iframeの高さを自動調整
  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      const handleLoad = () => {
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
          if (iframeDoc) {
            const height = iframeDoc.documentElement.scrollHeight;
            iframe.style.height = `${Math.max(height, 400)}px`;
          }
        } catch (error) {
          console.log('iframe height adjustment failed:', error);
        }
      };
      
      iframe.addEventListener('load', handleLoad);
      return () => iframe.removeEventListener('load', handleLoad);
    }
  }, [content]);

  // プレビュー用のHTML生成
  const previewHtmlDoc = generateTailwindHtmlDoc({
    content: content,
    title: "プレビューコンテンツ",
    includeBodyPadding: false
  });

  return (
    <>
      <DetailHeaderSC>
        {/* タイトル */}
        <ArticleTitleSC>{title}</ArticleTitleSC>

        {/* タグ */}
        <TagListSC>
          {isPublished
            ? tags.map(tag => <TagItemSC key={tag.id}>{tag.name}</TagItemSC>)
            : tags.map((tag: any) => {
                if (
                  currentTagIds.some(
                    (currentTagIds: { id: number }) =>
                      currentTagIds.id === tag.id
                  )
                ) {
                  return <TagItemSC key={tag.id}>{tag.name}</TagItemSC>;
                } else {
                  return null;
                }
              })}
        </TagListSC>
      </DetailHeaderSC>

      {/* コンテンツ */}
      <DetailContentsSC>
        {props.content && typeof props.content === "string" && (
          <TailwindContentFrame
            ref={iframeRef}
            srcDoc={previewHtmlDoc}
            title="プレビューコンテンツ"
            sandbox="allow-scripts"
          />
        )}
      </DetailContentsSC>
    </>
  );
}

export default ManualEditPreviewContent;
// ===================================================================================
// スタイル
// ===================================================================================

const DetailHeaderSC = styled.div`
  width: 100%;
  padding: 24px 16px;
  border-bottom: 1px solid ${color.divide_border};
  position: relative;
  ${pc`
    padding: 30px;
  `}
`;

const TagListSC = styled.ul`
  display: flex;
  margin-bottom: 16px;
  ${pc`
    margin-bottom: 0;
  `}
`;

const TagItemSC = styled.li`
  display: inline-block;
  color: ${color.gray};
  font-size: 12px;
  border-radius: 10px;
  margin-right: 8px;
  &::before {
    content: "";
    width: 12px;
    height: 12px;
    display: inline-block;
    background-image: url(${tag});
    background-repeat: no-repeat;
    background-position: left center;
    margin-right: 3px;
  }
`;

const ArticleTitleSC = styled.h2`
  color: ${color.gray};
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  letter-spacing: 3px;
  margin: 0 0 16px 0;
  ${pc`
    font-size: 20px;
  `}
`;

const DetailContentsSC = styled.div`
  padding: 30px 16px 24px;
  ${pc`
    padding: 30px;
  `}
`;

const TailwindContentFrame = styled.iframe`
  width: 100%;
  height: auto;
  min-height: 400px;
  border: none;
  background-color: white;
`;
